import React, { useState } from 'react'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { Alert, Box, Divider, Grid, Paper, Typography } from '@mui/material'
import { GlobalNotificationType, GlobalNotificationProto } from '../../../proto/generated/global-notification'
import { selectGlobalNotifications } from '../../../selectors/globalNotification'
import { useStyles } from './styles'
import EmptyGlobalNotificationView from '../EmptyGlobalNotificationView/EmptyGlobalNotificationView'
import { GLOBAL_NOTIFICATION_MEDIA_BASE_URL } from '../../../assets/constants'
import UpdatesIcon from '../../../assets/icons/UpdatesIcon'

const ProductAnnouncements = () => {
    const notifications: GlobalNotificationProto[] = useSelector(selectGlobalNotifications)
    const { classes } = useStyles()
    const [expandedMap, setExpandedMap] = useState<Record<string, boolean>>({})

    const productAnnouncements = notifications.filter((notification) => notification.type === GlobalNotificationType.PRODUCT_ANNOUNCEMENT && notification.enabled).sort((a, b) => b.updatedAt - a.updatedAt)

    const handleLinkClick = (link?: string) => {
        if (link) {
            const fullUrl = link.startsWith('http') ? link : `https://${link}`
            window.open(fullUrl, '_blank', 'noopener,noreferrer')
        }
    }

    return (
        <Paper className={classes.container}>
            <Grid container sx={{ flex: productAnnouncements.length > 0 ? 0 : 1, display: 'flex', flexDirection: 'row' }}>
                {productAnnouncements.length > 0 ? (
                    productAnnouncements.map((announcement: GlobalNotificationProto) => (
                        <Grid item xs={12} key={announcement.id} padding={0}>
                            <Alert severity="info" icon={<UpdatesIcon />} sx={{ color: 'inherit', background: 'none', boxShadow: 'none', '& .MuiAlert-icon': { marginRight: '7px' } }}>
                                <Typography
                                    className={`${classes.announcementHeader} ${announcement.link ? classes.clickable : ''}`}
                                    onClick={announcement.link ? () => handleLinkClick(announcement.link) : undefined}
                                >
                                    {announcement.header}
                                </Typography>
                                {announcement.message && (
                                    <Typography
                                        sx={{
                                            display: '-webkit-box',
                                            WebkitLineClamp: expandedMap[announcement.id] ? 'unset' : 2,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            fontSize: '14px'
                                        }}
                                    >
                                        {announcement.message}
                                    </Typography>
                                )}

                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    {announcement.message && announcement.message.length > 100 && !expandedMap[announcement.id] && (
                                        <Typography
                                            component="span"
                                            color="inherit"
                                            fontSize={'0.75rem'}
                                            sx={{ cursor: 'pointer', fontWeight: 'bold' }}
                                            onClick={() => setExpandedMap((prev) => ({ ...prev, [announcement.id]: true }))}
                                        >
                                            {' Read more'}
                                        </Typography>
                                    )}

                                    {announcement.message && announcement.message.length > 100 && expandedMap[announcement.id] && (
                                        <Typography
                                            component="span"
                                            color="inherit"
                                            fontSize={'0.75rem'}
                                            sx={{ cursor: 'pointer', fontWeight: 'bold' }}
                                            onClick={() => setExpandedMap((prev) => ({ ...prev, [announcement.id]: false }))}
                                        >
                                            {' Show less'}
                                        </Typography>
                                    )}
                                </Box>

                                {announcement.imageS3Key && (
                                    <Box sx={{ mt: 1, mb: 1 }}>
                                        <Box
                                            component="img"
                                            src={`${GLOBAL_NOTIFICATION_MEDIA_BASE_URL}${announcement.imageS3Key}`}
                                            alt={announcement.header || 'Product Announcement'}
                                            className={`${classes.announcementImage} ${announcement.link ? classes.clickable : ''}`}
                                            onClick={announcement.link ? () => handleLinkClick(announcement.link) : undefined}
                                            sx={{
                                                width: '350px',
                                                height: '200px',
                                                objectFit: 'contain'
                                            }}
                                        />
                                    </Box>
                                )}

                                <span style={{ fontSize: '0.75rem' }}>{dayjs(announcement.updatedAt).format('DD-MM-YYYY HH:mm A')}</span>
                            </Alert>
                            <Divider key={`divider-${announcement.id}`} />
                        </Grid>
                    ))
                ) : (
                    <Grid container className={classes.emptyContainer}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                            <EmptyGlobalNotificationView />
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Paper>
    )
}

export default ProductAnnouncements
